import { useEffect, useRef } from "react";

/**
 * Helper effect to achieve "prevProps" on useEffect hook
 */
export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
